'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @author yongsheng.zhang
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 测试分享回流
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * 2017.03.31
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */


var _utilGetUrl = require('@dp/util-get-url');

var _utilGetUrl2 = _interopRequireDefault(_utilGetUrl);

var _utilMUa = require('@dp/util-m-ua');

var _utilMUa2 = _interopRequireDefault(_utilMUa);

require('whatwg-fetch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @_social_u {string} 用户信息
 * @_social_e {string} 来源信息
 * @_login {boolean} 用户是否登录
 * @from {string} 来源
 * @secondShare {string} 是否二次分享
 */
var param = {
    _social_u: (0, _utilGetUrl2.default)('_social_u') || '',
    _social_e: '',
    from: (0, _utilGetUrl2.default)('from') || '',
    _login: document.cookie.indexOf('dper') != -1 ? true : false,
    secondShare: (0, _utilGetUrl2.default)('second_s') || ''
};

var ua = (0, _utilMUa2.default)();

var SocialRecord = function () {
    function SocialRecord() {
        _classCallCheck(this, SocialRecord);
    }

    _createClass(SocialRecord, [{
        key: 'changeUrl',
        value: function changeUrl(url) {
            //在非APP环境下二次分享，则加上二次分享参数，不再记录请求
            if (!param.secondShare.trim() && ua.type != 'dpapp') {
                if (url.indexOf('?') != -1) {
                    return url + '&second_s=true';
                } else {
                    return url + '?second_s=true';
                }
            } else {
                return url;
            }
        }
    }, {
        key: 'init',
        value: function init() {
            //没有登录或者在APP里面则不做任何事,或者在app分享时未登录,二次分享
            if (!param._login || ua.type == 'dpapp' || !param._social_u.trim() || param.secondShare == 'true') return;
            if (ua.type == 'qq') {
                //QQ环境
                param._social_e = 'qq';
            } else {
                //微信环境
                if (param.from == 'timeline') {
                    //朋友圈
                    param._social_e = 'wx_friend';
                } else if (param.from == 'singlemessage' || param.from == 'groupmessage') {
                    //微信对话框
                    param._social_e = 'wx_message';
                }
            }
            var domain = void 0;
            if (location.href.indexOf('51ping') != -1) {
                domain = '//m.51ping.com';
            } else {
                domain = '//m.dianping.com';
            }
            fetch('' + location.protocol + domain + '/friend/potentialFriend?_social_u=' + param._social_u + '&_social_e=' + param._social_e, {
                method: 'GET',
                mode: 'cors',
                credentials: 'include'
            }).then(function (response) {
                return response.json();
            }).then(function (result) {
                console.log('add ptFriend success');
            }).catch(function (err) {
                console.log('add ptFriend fail');
            });
        }
    }]);

    return SocialRecord;
}();

exports.default = SocialRecord;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/util-record-friend/index/index.js
// module id = 327
// module chunks = 10 11 12 13 14 15 16 17 18